/**
 * @param string which needs to be sliced
 * @param length
 * */
export const sliceString = (text: string, length: number) =>
  text.length > length ? `${text.slice(0, length)}...` : text;
